module.exports = __webpack_public_path__ + "img/5J.4978fabf.png";